// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"4756aa5f","291":"92973e73","300":"c9debce5","449":"45c6f9ab","453":"963b6c70","519":"cc1ad68b","525":"57b276a6","756":"c5bf9f90","811":"f204b140"}[chunkId] + ".chunk.js";
};